import React from 'react'
import classNames from 'classnames'

import T from 'components/FormattedMessage'

import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

interface Props {
  className?: string
}

const styles = (theme: Theme) => {
  const lineStyle = createStyles({
    line: {
      content: '""',
      flex: 1,
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: theme.palette.grey['300'],
      margin: 'auto',
    },
  })

  return createStyles({
    outer: {
      display: 'flex',
      margin: theme.spacing() * 2,
      '&:before': lineStyle.line,
      '&:after': lineStyle.line,
    },
    inner: {
      paddingLeft: theme.spacing() * 2,
      paddingRight: theme.spacing() * 2,
    },
  })
}

type InjectedProps = Props & WithStyles<typeof styles>

const Or: React.SFC<InjectedProps> = ({ className, classes }) => (
  <div className={classNames(className, classes.outer)}>
    <Typography variant="subtitle1" className={classes.inner}>
      <T id="landing_divider" />
    </Typography>
  </div>
)

export default withStyles(styles)(Or)
